// import { IntercomIdentifier } from '@gik/analytics/hooks/IntercomIdentifier';
import { useEnvStore } from '@gik/core/store/EnvStore';
import dynamic from 'next/dynamic';
import React from 'react';
import type { IntercomLazyProviderProps } from './IntercomLazyProvider';

const IntercomProvider = dynamic(() => import('react-use-intercom').then(mod => mod.IntercomProvider), {
  ssr: false,
});

type IntercomBooterProps = {};

const IntercomLazyProvider = dynamic<IntercomLazyProviderProps>(
  () => import('./IntercomLazyProvider').then(mod => mod.IntercomLazyProvider),
  {
    ssr: false,
  }
);

export function IntercomBooter({ children }: React.PropsWithChildren<IntercomBooterProps>) {
  const appId = useEnvStore(state => state.INTERCOM_APP_ID);

  return (
    <IntercomProvider appId={appId}>
      <IntercomLazyProvider>{children}</IntercomLazyProvider>
    </IntercomProvider>
  );
}
